"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoContainer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _VideoPlayer = require("./VideoPlayer");

var _ = require("../../");

var _VideoPlayerControls = require("./VideoPlayerControls");

var _VideoSettingsModal = require("./VideoSettingsModal");

var _loadVideoSettings = require("../VideoSettingsDialog/loadVideoSettings");

var _saveVideoSettings = require("../VideoSettingsDialog/saveVideoSettings");

var _useVideoSettings2 = require("./useVideoSettings");

var _useFluidPlayer2 = require("./useFluidPlayer");

require("./VideoContainer.css");

var _excluded = ["momentTicks", "containerRef", "radar", "spotlight", "items", "children", "videoSettings", "extraUserControls", "extraVideoControls", "startAt", "startAtOnce", "stopAt", "freeze", "toaster", "trackingPlaylistId", "trackingPlaylistType", "trackingUserId", "trackingPlayerType", "trackingCategory", "trackingAction", "onRadarEvent", "coachAudio", "cameras", "defaultCamera", "videoSettingsKey", "noMulticam", "multicamTooltipOpen", "onMulticamTooltipClose", "fullScreenElementSelector", "superFollow", "disabledControls", "watermark", "className", "forceActive"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var VideoContainer = function VideoContainer(_ref) {
  var momentTicks = _ref.momentTicks,
      containerRef = _ref.containerRef,
      radar = _ref.radar,
      spotlight = _ref.spotlight,
      items = _ref.items,
      children = _ref.children,
      videoSettings = _ref.videoSettings,
      extraUserControls = _ref.extraUserControls,
      extraVideoControls = _ref.extraVideoControls,
      startAt = _ref.startAt,
      startAtOnce = _ref.startAtOnce,
      stopAt = _ref.stopAt,
      freeze = _ref.freeze,
      toaster = _ref.toaster,
      trackingPlaylistId = _ref.trackingPlaylistId,
      trackingPlaylistType = _ref.trackingPlaylistType,
      trackingUserId = _ref.trackingUserId,
      trackingPlayerType = _ref.trackingPlayerType,
      trackingCategory = _ref.trackingCategory,
      trackingAction = _ref.trackingAction,
      onRadarEvent = _ref.onRadarEvent,
      coachAudio = _ref.coachAudio,
      cameras = _ref.cameras,
      defaultCamera = _ref.defaultCamera,
      videoSettingsKey = _ref.videoSettingsKey,
      noMulticam = _ref.noMulticam,
      multicamTooltipOpen = _ref.multicamTooltipOpen,
      onMulticamTooltipClose = _ref.onMulticamTooltipClose,
      fullScreenElementSelector = _ref.fullScreenElementSelector,
      superFollow = _ref.superFollow,
      disabledControls = _ref.disabledControls,
      watermark = _ref.watermark,
      className = _ref.className,
      forceActive = _ref.forceActive,
      props = _objectWithoutProperties(_ref, _excluded);

  // setup playlist controller and controller ref
  // eslint-disable-next-line no-unused-vars
  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      containerId = _useState2[0],
      setContainerId = _useState2[1]; // update containerRef property from parent if needed


  (0, _react.useEffect)(function () {
    setContainerId("video-container-".concat(containerRef.current));
  }, [containerRef === null || containerRef === void 0 ? void 0 : containerRef.current]);
  var videoContainerClassNames = ["VideoContainer"];

  if (className) {
    videoContainerClassNames.push(className);
  }

  var _useVideoSettings = (0, _useVideoSettings2.useVideoSettings)(containerRef),
      loop = _useVideoSettings.loop,
      locked = _useVideoSettings.locked,
      setLocked = _useVideoSettings.setLocked,
      setLoop = _useVideoSettings.setLoop; // setup playlist controls for this controller


  var _useFluidPlayer = (0, _useFluidPlayer2.useFluidPlayer)(containerRef),
      playlistController = _useFluidPlayer.playlistController,
      fluidSource = _useFluidPlayer.fluidSource,
      currentMoment = _useFluidPlayer.currentMoment; // get/set the video settings from local storage if they exist


  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      muted = _useState4[0],
      setMuted = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      zoomed = _useState6[0],
      setZoomed = _useState6[1];

  var _useState7 = (0, _react.useState)(1),
      _useState8 = _slicedToArray(_useState7, 2),
      playbackRate = _useState8[0],
      setPlaybackRate = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      videoSettingsDialogOpen = _useState10[0],
      _setVideoSettingsDialogOpen = _useState10[1];

  (0, _react.useEffect)(function () {
    (0, _loadVideoSettings.loadVideoSettings)(videoSettingsKey).then(function (settings) {
      setMuted((0, _.getProperty)("muted", settings));
      setPlaybackRate((0, _.getProperty)("speed", settings));
    });
  }, [_loadVideoSettings.loadVideoSettings, setMuted, setZoomed, setPlaybackRate]);

  var handleOnMulticamTooltipClose = function handleOnMulticamTooltipClose() {
    if (typeof onMulticamTooltipClose === "function") {
      onMulticamTooltipClose();
    }
  };

  var handleVideoSettingsChange = function handleVideoSettingsChange(settings, done) {
    if (settings) {
      var updatedSettings = {
        muted: muted,
        speed: playbackRate
      }; // muted

      var newMuted = (0, _.getProperty)("muted", settings, null);

      if (newMuted !== null) {
        setMuted(newMuted);
        updatedSettings.muted = newMuted;
      } // playback rate


      var newPlaybackRate = (0, _.getProperty)("speed", settings, null);

      if (newPlaybackRate !== null) {
        setPlaybackRate(newPlaybackRate);
        updatedSettings.speed = newPlaybackRate;
      }

      (0, _saveVideoSettings.saveVideoSettings)(updatedSettings, videoSettingsKey);
    }

    if (done) {
      _setVideoSettingsDialogOpen(false);
    }
  };

  var camerasCount = cameras ? cameras.length : 0;
  (0, _react.useEffect)(function () {
    console.log("VideoContainer currentMoment changed", currentMoment);
  }, [currentMoment]);
  (0, _react.useEffect)(function () {
    console.log("VideoContainer fluidSource changed", fluidSource);
    console.log("VideoContainer pc", playlistController);
  }, [fluidSource]);
  return /*#__PURE__*/_react.default.createElement(_.Element, _extends({}, props, {
    id: containerId,
    className: videoContainerClassNames.join(" ")
  }), /*#__PURE__*/_react.default.createElement(_VideoSettingsModal.VideoSettingsModal, {
    muted: muted,
    playbackRate: playbackRate,
    zoomed: zoomed,
    locked: locked,
    loopMomentPlay: loop,
    setLocked: setLocked,
    setLoop: setLoop,
    videoSettingsDialogOpen: videoSettingsDialogOpen,
    setVideoSettingsDialogOpen: function setVideoSettingsDialogOpen(e) {
      return _setVideoSettingsDialogOpen(false);
    },
    handleVideoSettingsChange: handleVideoSettingsChange,
    videoSettingsKey: videoSettingsKey
  }), /*#__PURE__*/_react.default.createElement(_VideoPlayer.VideoPlayer, {
    startAt: startAt,
    startAtOnce: startAtOnce,
    stopAt: stopAt,
    freeze: freeze,
    loop: loop,
    containerRef: containerRef,
    moment: playlistController !== null && playlistController !== void 0 && playlistController.fluid ? fluidSource : currentMoment,
    displayMoment: currentMoment,
    muted: muted,
    zoomed: zoomed,
    locked: locked,
    playbackRate: playbackRate,
    trackingPlaylistId: trackingPlaylistId,
    trackingPlaylistType: trackingPlaylistType,
    trackingUserId: trackingUserId,
    trackingPlayerType: trackingPlayerType,
    trackingCategory: trackingCategory,
    trackingAction: trackingAction,
    radar: radar,
    spotlight: spotlight,
    watermark: watermark,
    superFollow: superFollow,
    coachAudio: coachAudio,
    cameras: cameras,
    noMulticam: noMulticam,
    defaultCamera: defaultCamera,
    forceActive: forceActive
  }, /*#__PURE__*/_react.default.createElement(_VideoPlayerControls.VideoPlayerControls, {
    momentTicks: momentTicks,
    fullGameTime: fluidSource === null || fluidSource === void 0 ? void 0 : fluidSource.full_game_time,
    items: items,
    locked: locked,
    loop: loop,
    toaster: toaster,
    noMulticam: noMulticam,
    camerasCount: camerasCount,
    containerRef: containerRef,
    extraUserControls: extraUserControls,
    extraVideoControls: extraVideoControls,
    onOpenVideoSettingsDialog: _setVideoSettingsDialogOpen,
    multicamTooltipOpen: multicamTooltipOpen,
    onMulticamTooltipClose: handleOnMulticamTooltipClose,
    fullScreenElementSelector: fullScreenElementSelector,
    disabledControls: disabledControls,
    onVideoSettingsChange: handleVideoSettingsChange
  }, children)));
};

exports.VideoContainer = VideoContainer;